import api from 'utils/api';
import { getAPIBase } from "utils/api/apiBase";
import { mapTrackToAsset } from 'api/utils';

export const searchTracks = async (query, permissions) =>
  api
    .get(
      `${getAPIBase()}/search/`,
      {params: {content_type: 'tracks', query: query, permissions: permissions.join()}},
    )
    .then((response) => response.data.results.tracks.map((track) => mapTrackToAsset(track)));
